




















import PaymentCheckoutStatus from '@accounting/components/payment-checkout-status.vue';
import { PaymentMethod } from '@accounting/interfaces/payment-method';
import {
  ShoppingCartOrderDetail,
  ShoppingCartResponse,
  ShoppingCartTicket,
} from '@accounting/interfaces/shopping-cart';
import BPCStripeService from '@accounting/services/bpc-stripe-api.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ShoppingCartWizardPaymentMethodStep from './shopping-cart-wizard-payment-method-step.vue';
import ShoppingCartWizardProductListStep from './shopping-cart-wizard-product-list-step.vue';
import BlockingOverlay from '@shared/components/overlay/blocking-overlay.vue';

@Component({
  name: 'bpc-shopping-cart-wizard',
  components: {
    'bpc-shopping-cart-wizard-product-list-step': ShoppingCartWizardProductListStep,
    'bpc-shopping-cart-wizard-payment-method-step': ShoppingCartWizardPaymentMethodStep,
    'bpc-payment-checkout-status': PaymentCheckoutStatus,
    'bc-blocking-overlay': BlockingOverlay,
  },
})
export default class ShoppingCartWizard extends Vue {
  @Prop({ type: String, default: 'product-list' }) readonly step: string;

  selectedOrders: ShoppingCartOrderDetail[] = [];
  selectedPaymentMethod: PaymentMethod = null;
  paymentResponse: ShoppingCartResponse = null;
  ticket: ShoppingCartTicket = null;
  isPopupOpen: boolean = false;
  paymentId: number = null;
  paymentStatus: string = null;

  get totalPrice(): number {
    return this.selectedOrders.reduce((res, orderDetail) => {
      return res + orderDetail.total_price;
    }, 0);
  }
  get isFree(): boolean {
    return this.selectedOrders && this.selectedOrders.length && this.totalPrice === 0;
  }

  get showMoneyTransferInfo(): boolean {
    return (
      this.step === 'confirmation' &&
      this.paymentResponse.paymentMethod.provider === 'money_transfer'
    );
  }

  get showStatus(): boolean {
    return this.showMoneyTransferInfo || this.showPayFipPaymentInfo;
  }

  get status(): string {
    if (this.showMoneyTransferInfo) {
      return 'success-money-transfer';
    } else if (this.showPayFipPaymentInfo) {
      if (this.paymentStatus === 'success') return 'success';
      if (this.paymentStatus === 'failed') return 'cancel';
      return 'ongoing-payfip';
    }
    return '';
  }

  get showPayFipPaymentInfo(): boolean {
    return this.step === 'confirmation' && this.paymentResponse.paymentMethod.provider === 'payfip';
  }

  onProductSelected(selectedOrderDetails: ShoppingCartOrderDetail[]) {
    this.selectedOrders = selectedOrderDetails;
    this.createTicket();
    this.$emit('step-change', 'payment-method');
  }
  async onPaymentMethodSelected(selectedPaymentMethod: PaymentMethod) {
    this.selectedPaymentMethod = selectedPaymentMethod;
    await this.sendPayment();
    this.$emit('step-change', 'confirmation');
  }

  public createTicket() {
    const basePath = this.$bpcApiRouteHelper.getApiPath('shopping-cart/ticket');
    const body = {
      orderIds: this.selectedOrders.map(value => value.id),
    };
    this.$bpcApi.post(basePath, body).subscribe(
      response => {
        this.ticket = response.data;
      },
      error => {
        const message = error?.response?.data?.message;
        this.$bpcMessage.showErrorMessage({ text: message });
      },
    );
  }

  async sendPayment() {
    const bpcStripe = new BPCStripeService();
    // FIXME can ticket be null at this stage ? invoice checkout ?
    this.paymentResponse = await bpcStripe.getPaymentLink(this.selectedPaymentMethod, this.ticket);
    if (this.paymentResponse.paymentMethod.provider !== 'money_transfer') {
      this.paymentId = this.paymentResponse.paymentId;
      // NOTE Maybe instead of checking directly money transfer we could add a
      // property in the response if we have the need of this behaior in future
      // payment methods
      if (this.paymentResponse.response.openInAPopUp) {
        const popup = window.open(
          this.paymentResponse.response.redirectUrl,
          '_blank',
          'height=700, width=900,toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no',
        );
        if (popup) {
          this.isPopupOpen = true;
          const focusPopup = () => {
            if (!popup.closed) {
              popup.focus();
            }
          };

          window.addEventListener('click', focusPopup);
          const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkPopupClosed);
              window.removeEventListener('click', focusPopup);
              this.isPopupOpen = false;
            }
          }, 500);
          this.checkPaymentStatus(this.paymentId);
        }
      } else {
        window.location.href = this.paymentResponse.response.redirectUrl;
      }
    }
  }
  goToStep(step: string) {
    this.$emit('step-change', step);
  }

  checkPaymentStatus(paymentId: number) {
    this.$bpcEcho
      .getOnlinePaymentStatusChannel(paymentId)
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentSuccess', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'success';
      })
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentFailed', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'failed';
      });
  }
}
